// extracted by mini-css-extract-plugin
module.exports = {"TileWrap":"PreviewTile_TileWrap__2ZJ4V","PreviewTile":"PreviewTile_PreviewTile__2l4fJ","ActiveTile":"PreviewTile_ActiveTile__3kjZp","border":"PreviewTile_border__1N56A"};